<script>
import 'slick-carousel/slick/slick.css'

export default {
  components: {
    Slick: () => import("vue-slick"),
    SlickPagination: () => import("@components/Slick/SlickPagination"),
  },
  props: {
    carouselList: {
      type: Array,
      default: () => {
        return [
          {
            "path": "https://assets.codepen.io/1759070/service-1%402x.png",
            "default": 1
          },
          {
            "path": "https://assets.codepen.io/1759070/service-2%402x.png",
            "default": 0
          },
          {
            "path": "https://assets.codepen.io/1759070/service-3%402x.png",
            "default": 0
          }
        ]
      }
    },
  },
  data() {
    const DEFAULT_PAGE_COUNT = 1;

    return {
      pageCount: DEFAULT_PAGE_COUNT,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        arrows: true,
        centerPadding: '0',
        touchThreshold: 6,
        centerMode: true,
        dots: false,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>'
      },
    }
  },
  methods: {
    onSlideTo(index) {
      this.$refs.slick.goTo(index - 1)
    },
    onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.pageCount = nextSlide + 1
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.itemCarouselImageJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <Slick
      ref="slick"
      :options="slickOptions"
      class="slick isStyleBase"
      :class="$style.carouselList"
      @beforeChange="onBeforeChange"
    >
      <div
        v-for="(carouseItem, index) in carouselList"
        :key="`carouseItem-${index}`"
        class="carouselList__item"
      >
        <div
          class="carouselList__image"
          :style="{ backgroundImage: `url('${ carouseItem.path }')` }"
        ></div>
      </div>
    </Slick>
    <SlickPagination
      v-model="pageCount"
      :total="carouselList.length"
      class="itemCarouselImageJtails__pagination"
      type="white"
      @change="onSlideTo"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.carouselList {
  :global {
    .carouselList {
      &__item {
        margin-bottom: -1rem;
      }

      &__image {
        padding-top: 73%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
    }
  }
}

.itemCarouselImageJtails {
  position: relative;
  z-index: 0;
  overflow: hidden;

  &:hover {
    :global {
      // stylelint-disable selector-class-pattern
      .slick-arrow {
        opacity: 1;
      }

      // stylelint-enable selector-class-pattern
    }
  }

  // stylelint-disable-next-line no-descending-specificity
  :global {
    .itemCarouselImageJtails {
      &__pagination {
        position: absolute;
        bottom: 1.5rem;
        left: 50%;
        z-index: 1;
        transform: translateX(-50%);
      }
    }

    // stylelint-disable selector-class-pattern, no-descending-specificity
    .slick-arrow {
      // height: calc(100% - 6px);
      // width: 100px;
      position: absolute;
      top: 50%;
      // top: 0;
      z-index: 1;
      width: 70px;
      height: 70px;
      font-size: 0;
      color: #fff;
      // background: transparent;
      background: rgba(#000, 25%);
      border: unset;
      opacity: 0.6;
      transition: opacity 0.3s;
      transform: translateY(-50%);
      appearance: none;

      @include max-md {
        width: 50px;
        height: 50px;
      }

      &::before {
        font-size: 2.75rem;

        @include max-md {
          font-size: 2rem;
        }
      }

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover {
        opacity: 1;
      }

      &:active {
        opacity: 0.4;
        transition: opacity 0s;
      }

      &.slick-prev {
        left: 0;

        @media (min-width: 1920px) {
          left: calc((100vw - 1920px) / 2);
        }

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-left-helf;
        }

        &::after {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }

      &.slick-next {
        right: 0;

        @media (min-width: 1920px) {
          right: calc((100vw - 1920px) / 2);
        }

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-right-helf;
        }

        &::after {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }
    }

    // stylelint-enable selector-class-pattern, no-descending-specificity
  }

  &.isStyleDingBeauty {
    :global {
      .slick-arrow { 
        height: 40px;
        background: rgba(#fff, 0.6);
        &::before {
          color: $color-secondary;
          font-size: 2.35rem;
        }
        &::after {
          background: #fff;
          opacity: 0;
        }
        &:hover {
          &:after {
            opacity: 1;
          }
        }
      }
    }
  }
}


</style>
